import { FixedAssetRegisterTypes } from "./fixedAssetRegisterTypes";

export const fixedAssetRegisterReducer = {
  resetFixedAssetRegisterFetching: (state: FixedAssetRegisterTypes) => {
    state.fetching = false;
  },
  resetFixedAssetRegisterError: (state: FixedAssetRegisterTypes) => {
    state.error = null;
  },

  resetFixedAssetRegisterSuccess: (state: FixedAssetRegisterTypes) => {
    state.success = null;
  },
  resetFinacAssetId: (state: FixedAssetRegisterTypes) => {
    state.finacAssetId = null;
  },
  resetFixedAssetRegisterListing: (state: FixedAssetRegisterTypes) => {
    state.finacAssetListing = [];
  },
  resetFixedAssetRegisterMessage: (state: FixedAssetRegisterTypes) => { 
    state.message = null;
  },
  resetSingleFixedAsset: (state: FixedAssetRegisterTypes) => {
    state.singleFixedAsset={}
  },
 
  resetFixedAssetRegisterTotalCount: (state: FixedAssetRegisterTypes) => { 
    state.totalCount = 0;
  },
  resetFixedAssetRegisterStatusCode: (state: FixedAssetRegisterTypes) => { 
    state.statusCode=null
  },
  resetFixedAssetHistoryData: (state: FixedAssetRegisterTypes) => { 
    state.fixedAssetHistoryData=[];
  },
  resetFixedAssetHistorySuccess: (state: FixedAssetRegisterTypes) => { 
    state.fixedAssetHistorySuccess=null;
  },
  resetBulkUpload: (state: FixedAssetRegisterTypes) => {
  state.bulkUploadData={}
  },
  resetAuditSessionListing:(state :FixedAssetRegisterTypes)=>{
    state.auditSessionListing = [];
  },
  resetAuditSessionTotalCount:(state:FixedAssetRegisterTypes)=>{
     state.auditSessionTotalCount=0;
  },
  resetFixedAssetUsersHistoryData:(state:FixedAssetRegisterTypes)=>{
     state.fixedAssetUsersHistoryData=[];
  },
};
